import React from "react"

const BarcodeManuallyIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
    >
      <g clipPath="url(#clip0_13231_6217)">
        <path
          d="M3.5 7V5C3.5 4.46957 3.71071 3.96086 4.08579 3.58579C4.46086 3.21071 4.96957 3 5.5 3H7.5M17.5 3H19.5C20.0304 3 20.5391 3.21071 20.9142 3.58579C21.2893 3.96086 21.5 4.46957 21.5 5V7M7.5 21H5.5C4.96957 21 4.46086 20.7893 4.08579 20.4142C3.71071 20.0391 3.5 19.5304 3.5 19V17M6.5 7V17M10.5 7V17M14.5 7V11.5M17.5 7V9M18.9156 11.2475L19.472 10.691C19.6912 10.4719 19.9513 10.2981 20.2376 10.1795C20.5239 10.061 20.8308 9.99997 21.1406 10C21.4505 10 21.7573 10.0611 22.0436 10.1797C22.3299 10.2983 22.59 10.4722 22.8091 10.6913C23.0282 10.9105 23.2019 11.1706 23.3205 11.4569C23.439 11.7432 23.5 12.0501 23.5 12.36C23.5 12.6699 23.4389 12.9767 23.3203 13.263C23.2017 13.5493 23.0278 13.8094 22.8087 14.0285L22.2522 14.5835M18.9156 11.2475C18.9156 11.2475 18.9853 12.4295 20.0278 13.472C21.0702 14.5145 22.2522 14.5835 22.2522 14.5835M18.9156 11.2475L13.803 16.3602C13.4565 16.7067 13.2832 16.8792 13.1347 17.0705C12.9588 17.2955 12.8082 17.5392 12.6855 17.7972C12.5812 18.0155 12.504 18.248 12.3487 18.7122L11.6925 20.6817M22.2522 14.5835L17.1396 19.697C16.7931 20.0435 16.6206 20.216 16.4294 20.3652C16.2039 20.5412 15.9616 20.691 15.7026 20.8145C15.4844 20.9187 15.2519 20.996 14.7877 21.1505L12.8182 21.8075M11.6925 20.6817L11.5328 21.1625C11.4953 21.2746 11.4899 21.3949 11.517 21.5099C11.5441 21.6249 11.6027 21.7302 11.6863 21.8137C11.7698 21.8973 11.875 21.9559 11.9901 21.983C12.1051 22.0102 12.2254 22.0047 12.3375 21.9672L12.8182 21.8075M11.6925 20.6817L12.8182 21.8075"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.5 21H19.5C20.0304 21 20.5391 20.7893 20.9142 20.4142C21.2893 20.0391 21.5 19.5304 21.5 19"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_13231_6217">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export default BarcodeManuallyIcon
